

  <header>
  <!-- Insert header here -->
 
    <app-nav></app-nav>
    
  
  </header>

    <div>
      
      <router-outlet>
      </router-outlet>
      <div class="cursor" [style.top]="top" [style.left]="left" [ngClass]="{'expand':expand}"></div>
    </div>
    
  <!-- <footer >
<p>&copy; K Dordevic 2021</p>
  </footer> -->


